import dayjs from 'dayjs';
import 'dayjs/locale/pl';
import relativeTime from 'dayjs/plugin/relativeTime';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import utc from 'dayjs/plugin/utc';
import tz from 'dayjs/plugin/timezone';

dayjs.extend(relativeTime);
dayjs.extend(localizedFormat);
dayjs.extend(utc);
dayjs.extend(tz);

import i18n from '@/i18n';

const localeFor = (): string => {
  const lang = i18n.language || 'en';
  return lang.startsWith('pl') ? 'pl' : 'en';
};

export const formatDate = (iso: string | null | undefined, fmt: string = 'L'): string => {
  if (!iso) return '';
  return dayjs(iso).locale(localeFor()).format(fmt);
};

export const formatDateTime = (iso: string | null | undefined): string => {
  if (!iso) return '';
  return dayjs(iso).locale(localeFor()).format('L LT');
};

export const formatTime = (iso: string | null | undefined): string => {
  if (!iso) return '';
  return dayjs(iso).locale(localeFor()).format('LT');
};

export const formatRelative = (iso: string | null | undefined): string => {
  if (!iso) return '';
  return dayjs(iso).locale(localeFor()).fromNow();
};

export const formatPrice = (amount: string | number | null | undefined, currency: string): string => {
  if (amount === null || amount === undefined || amount === '') return '';
  const num = typeof amount === 'string' ? parseFloat(amount) : amount;
  if (Number.isNaN(num)) return '';
  try {
    return new Intl.NumberFormat(localeFor(), {
      style: 'currency',
      currency,
      maximumFractionDigits: 2,
    }).format(num);
  } catch {
    return `${num.toFixed(2)} ${currency}`;
  }
};

export const formatPercent = (value: string | number | null | undefined, fractionDigits = 0): string => {
  if (value === null || value === undefined || value === '') return '';
  const num = typeof value === 'string' ? parseFloat(value) : value;
  if (Number.isNaN(num)) return '';
  // Accept either 0-1 or 0-100. Heuristic: if >1, treat as already percent.
  const pct = num > 1 ? num : num * 100;
  return `${pct.toFixed(fractionDigits)}%`;
};

export const truncate = (s: string | null | undefined, n: number): string => {
  if (!s) return '';
  return s.length > n ? `${s.slice(0, n - 1)}…` : s;
};
